import { render } from "./Publications.vue?vue&type=template&id=5263bd64&scoped=true"
import script from "./Publications.vue?vue&type=script&lang=js"
export * from "./Publications.vue?vue&type=script&lang=js"

import "./Publications.vue?vue&type=style&index=0&id=5263bd64&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/scga-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5263bd64"]])

export default __exports__